import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import CloseModal from "./close-modal";

const BottomModal = React.forwardRef(
  ({ isOpen, render, hasCloseButton, onClose, shouldCloseOnOverlayClick }, ref) => {
    const [modalIsOpen, setModalIsOpen] = useState(isOpen);
    useEffect(() => {
      setModalIsOpen(isOpen);
    }, [isOpen]);
    const handleClose = () => {
      onClose();
      setModalIsOpen(false);
    };
    return (
      <Modal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={handleClose}
        overlayClassName="react-modal--bottom"
        ref={ref}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
        {hasCloseButton && <CloseModal handleClose={handleClose} />}
        {render()}
      </Modal>
    );
  }
);

export default BottomModal;
